import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteService } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useDeleteService = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteSer,
        isPending: isDelete,
    } = useMutation({
        mutationFn: deleteService,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete service");
        },
    });

    return {
        deleteSer,
        isDelete,
    };
};

export default useDeleteService;
